'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleAnalytics = (_temp = _class = function (_SvgIcon) {
  _inherits(GoogleAnalytics, _SvgIcon);

  function GoogleAnalytics() {
    _classCallCheck(this, GoogleAnalytics);

    return _possibleConstructorReturn(this, (GoogleAnalytics.__proto__ || Object.getPrototypeOf(GoogleAnalytics)).apply(this, arguments));
  }

  _createClass(GoogleAnalytics, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement(
            'g',
            { id: 'google-analytics', transform: 'translate(10.000000, 8.000000)' },
            _react2['default'].createElement('path', {
              fill: '#F9AB00',
              transform: 'translate(30.207692, 0.000000)',
              d: 'M5.86257,-1.6e-05 C8.89141615,-1.6e-05 11.6446777,2.307024 11.6446777,5.999984 L11.6446777,41.726704 C11.6446777,46.090864 8.61583154,47.999664 5.86257,47.999664 C2.88977769,47.999664 0.0804623077,45.754864 0.0804623077,41.726704 L0.0804623077,5.726864 C0.0804623077,2.544784 2.83372385,-1.6e-05 5.86257,-1.6e-05'
            }),
            _react2['default'].createElement('path', {
              fill: '#E37400',
              d: 'M2.79299857e-06,42.296704 C0.00680076923,45.453024 2.59545462,48.006304 5.78196231,47.999744 C5.82622385,47.999984 5.87032385,47.999984 5.91442385,47.999744 C9.10803923,47.963424 11.6672931,45.369824 11.6306238,42.206784 C11.5941162,39.043584 8.97557769,36.508704 5.78196231,36.545024 L5.75773154,36.545024 C2.57122385,36.551584 -0.00676846154,39.115584 2.79299857e-06,42.271904 L2.79299857e-06,42.296704 Z M20.9261931,18.272864 C23.9550392,18.272864 26.7081392,20.579904 26.7081392,24.272864 L26.7081392,41.726624 C26.7081392,46.090944 23.6792931,47.999744 20.9261931,47.999744 C17.9458085,47.999744 15.1440854,45.755584 15.1440854,41.726624 L15.1440854,23.999904 C15.1440854,20.817504 17.8973469,18.272864 20.9261931,18.272864 L20.9261931,18.272864 Z'
            })
          )
        );
      }

      return render;
    }()
  }]);

  return GoogleAnalytics;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 64 64'
}, _temp);
exports['default'] = GoogleAnalytics;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/GoogleAnalytics.js
// module id = 1371
// module chunks = 32